export default {
    name: '姓名',
    tel: '电话',
    save: '保存',
    confirm: '确认',
    cancel: '取消',
    delete: '删除',
    complete: '完成',
    loading: '加载中...',
    telEmpty: '请填写电话',
    nameEmpty: '请填入你的名字',
    nameInvalid: '请输入有效的名字',
    confirmDelete: '你确定要删除吗',
    telInvalid: '请输入正确的电话号码',
    vanCalendar: {
        end: '结束',
        start: '开始',
        title: '标题',
        confirm: '确认',
        startEnd: '开始 结束',
        weekdays: ['日', '一', '二', '三', '四', '五', '六'],
    },
    vanCascader: {
        select: '请选择',
    },
    vanContactCard: {
        addText: '添加联系人',
    },
    vanContactList: {
        addText: '新联系人',
    },
    vanPagination: {
        prev: '上一页',
        next: '下一页',
    },
    vanPullRefresh: {
        pulling: '下拉刷新...',
        loosing: '释放刷新...',
    },
    vanSubmitBar: {
        label: '全部：',
    },
    vanCoupon: {
        unlimited: '没有使用限制',
    },
    vanCouponCell: {
        title: '优惠券',
        tips: '无法使用',
    },
    vanCouponList: {
        empty: '没有优惠券',
        exchange: '兑换',
        close: '没有优惠券',
        enable: '可用的',
        disabled: '无法使用',
        placeholder: '请输入优惠码',
    },
    vanAddressEdit: {
        area: '区域',
        postal: '邮政编码',
        areaEmpty: '选择地区',
        addressEmpty: '请填写详细地址',
        postalEmpty: '邮政编码格式不正确',
        defaultAddress: '设置为默认送货地址',
        telPlaceholder: '收货人手机号码',
        namePlaceholder: '收货人姓名',
        areaPlaceholder: '选择省/市/区',
    },
    vanAddressEditDetail: {
        label: '地址',
        placeholder: '街道门牌号、楼层房间号等信息',
    },
    vanAddressList: {
        add: '添加地址',
    },
};
